























































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import PopupAddDossier from '@/components/DossierAcademique/PopupAddDossier.vue'
import { PosteInterface, PosteType, PosteContext } from '@/types/Poste'
import { Etat, getEtatForFilterSelect } from '@/types/DossierAcademique'
import AssistantValidationDossier from '@/views/Dossiers/AssistantValidationDossier.vue'
import { checkIcone, formatDate } from '@/utils/helpers'
import CommentaireIntervenant from '@/components/SelectionRH/CommentaireIntervenant.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Ability } from '@/types/Ability'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import _ from 'lodash'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import PopUpInfoIntervenant from '@/components/PopupInfoIntervenant.vue'


@Component({
    components: {
        AssistantValidationDossier,
        PopupAddDossier,
        CommentaireIntervenant,
        ExaGenericTable,
        ErrorDisplay,
        PopUpInfoIntervenant,
        'font-awesome-icon': FontAwesomeIcon
    },
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapState('dossieracademique', ['viewDossier', 'meta', 'dossiersAcademiques', 'loading']),
        ...mapState('poste', ['postes']),
        ...mapGetters('dossieracademique', ['dossiersAcademiques', 'links', 'loading', 'error', 'totalRows', 'currentPage', 'lastPage', 'totalPage', 'sortby']),
        ...mapGetters('session', ['sessions'])
    },
    methods: {
        ...mapMutations('dossieracademique', ['SET_VIEW_DOSSIER']),
        ...mapActions('dossieracademique', ['getDossiersAcademiques', 'updateDossierAcademique'])
    }
})
export default class DossiersAcademiquesRespSps extends Vue {
    @Watch('meta')
    majInfosTable () {
        // On récupère le nombre total de dossiers filtrés depuis les infos des Metadonnées
        if (this.$store.state.dossieracademique.meta !== null) {
            if (this.$store.state.dossieracademique.meta && this.totalDossiers !== this.$store.state.dossieracademique.meta.total) {
                this.totalDossiers = this.$store.state.dossieracademique.meta.total
            }
        } else {
            this.totalDossiers = 0
        }
    }

    @Watch('dossiersAcademiques', { deep : true })
    wdossiersAcademiques() {
        const dossier = this.$store.getters['dossieracademique/dossiersAcademiques']
        this.setDataForGenericTab(dossier)
    }

    @Watch('user_session_id')
    refreshInterface () {
        this.load()
    }

    sortBy          = ''
    sortDesc        = false
    sortDirection   = 'asc'
    filter          = ''
    filterOn        = []
    stickyHeader    = true
    dossier_id      = 0
    params              = []
    enumEtats: Array<any> = []
    totalDossiers = 0
    datas = []
    user_select: any = {}
    showCommentaireIntervenant = false
    showModalInfoIntervenant = false
    user_id_temp = 0
    formatDate = formatDate
    // DATAS
    genericfields = [
        {
            key: 'edit',
            label: '',
            sortable: true,
            sortDirection: 'asc',
            class: 'text-center'
        },
        { key: 'etat', label: 'État', sortable: true, class: 'text-center', type: 'text' },
        {
            key: 'usercomment',
            label: '',
            sortable: false,
            sortDirection: 'asc',
            class: 'text-start ps-4 w-2'
        },
        // { key: 'user.name', label: 'Nom', sortable: true, sortDirection: 'asc', class: 'text-start ps-4' },
        // { key: 'user.first_name', label: 'Prénom', sortable: true, sortDirection: 'asc', class: 'text-start' },
        { key: 'user.name', label: 'Identité', sortable: true, sortDirection: 'asc', class: 'text-start ps-4',  type: 'actionText'  },
        {
            key: 'postes_souhaits',
            label: 'Postes',
            sortable: false,
            sortDirection: 'asc',
            class: 'text-start'
        },
        { key: 'concour.name', label: 'Filière', sortable: true, sortDirection: 'asc', class: 'text-start' },
        { key: 'matiere.name', label: 'Matière', sortable: true, sortDirection: 'asc', class: 'text-start' },
        {
            key: 'submitted_at',
            label: 'Déposé le',
            sortable: true,
            sortDirection: 'asc',
            class: 'text-start'
        }
        // { key: 'relance', label: 'Relance', class: 'text-center' }
    ]

    dataForTab: any = []

    filtres: any = []
    Ability = Ability

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setFiltersForGenericTab() {
        // Options filières
        const filieres = this.$store.getters['concour/banques']
        const options_filieres = []
        for (const f in filieres) {
            options_filieres.push({ index: filieres[f].id, name: filieres[f].name })
        }

        const matieres = this.$store.getters['matiere/matieres']
        const options_matieres = []
        for (const m in matieres) {
            options_matieres.push({ index: matieres[m].id, name: matieres[m].name })
        }

        const etat_souhait = this.getEnumEtats()

        const postes = this.$store.state.poste.postes.filter((p: PosteInterface) => (p.context & PosteContext.CONTEXT_SOUHAIT) === PosteContext.CONTEXT_SOUHAIT)
        const option_postes = []
        for (const p in postes) {
            option_postes.push({ index: postes[p].name, name: postes[p].name })
        }

        this.filtres = [
            {
                libelle: 'État',
                defautOptionlibelle: 'Tous les',
                model: 'etat',
                value: '',
                index: 'id',
                datas: etat_souhait,
                loading: '',
                options: { type: 'deroulant', fieldsKey: 'etat' }
            },
            /*
            {
                libelle: 'Nom',
                defautOptionlibelle: 'Rechercher un',
                model: 'user.name',
                value: '',
                datas: '',
                loading: this.$store.state.dossieracademique.loading,
                options: { type: 'form', fieldsKey: 'user.name' } // 'form' , 'deroulant'
            },
            {
                libelle: 'Prenom',
                defautOptionlibelle: 'Rechercher un',
                model: 'user.first_name',
                value: '',
                datas: '',
                loading: this.$store.state.dossieracademique.loading,
                options: { type: 'form', fieldsKey: 'user.first_name' } // 'form' , 'deroulant'
            },
            */
            {
                libelle: 'Nom',
                defautOptionlibelle: 'Rechercher un',
                model: 'user.name',
                value: '',
                datas: '',
                loading: this.$store.state.dossieracademique.loading,
                options: { type: 'form', fieldsKey: 'user.name' } // 'form' , 'deroulant'
            },
            {
                libelle: 'Postes',
                defautOptionlibelle: 'Tous les',
                model: 'posteSouhaits.name',
                value: '',
                index: 'name',
                datas: option_postes,
                loading: this.$store.state.poste.loading,
                options: { type: 'deroulant', fieldsKey: 'postes_souhaits' } // 'form' , 'deroulant'
            },

            {
                libelle: 'Filière',
                defautOptionlibelle: 'Rechercher une',
                model: 'concour_id',
                value: '',
                index: 'filiere',
                datas: options_filieres,
                loading: '',
                options: { type: 'deroulant', fieldsKey: 'concour.name' }
            },

            {
                libelle: 'Matières',
                defautOptionlibelle: 'Toutes les',
                model: 'matiere.id',
                value: '',
                index: 'name',
                datas: options_matieres,
                loading: this.$store.state.matiere.loading,
                options: { type: 'deroulant', fieldsKey: 'matiere.name' } // 'form' , 'deroulant'
            }
        ]
    }

    // params = 'sort=session_id&direction=asc'

    // METHODS

    // Récupère une énum des états de poste possible
    getEnumEtats () {
        this.enumEtats = []
        for (const etatName in Etat) {
            if (isNaN(Number(etatName))) {
                this.enumEtats.push({ id: getEtatForFilterSelect(etatName).index, name: getEtatForFilterSelect(etatName).libelle, index: getEtatForFilterSelect(etatName).index })
            }
        }
        return this.enumEtats
    }

    // création de la collection complète en fonction d'une demande de filtrage ou de tri
    filtreSortHandler (params: any) {
        this.params = params
        /* if (params.length === 0) {
            params = {
                page: 1,
                sort: 'user.name',
                direction: 'asc'
            }
        } */
        if (params.sort === '') {
            params.sort = 'user.name'
        }
        this.$store.dispatch('dossieracademique/getDossiersAcademiques', this.params)
    }

    // ajout des nouvelles entrées de liste lors d'un scroll
    loadHandler (params: any) {
        this.params = params
        if (params.length === 0) {
            params = {
                page: 1,
                sort: 'user.name',
                direction: 'asc'
            }
        } else if (params.sort === '') {
            params.sort = 'user.name'
        }
        if (params.page === 1) {
            this.$store.dispatch('dossieracademique/getDossiersAcademiques', this.params)
        } else {
            this.$store.dispatch('dossieracademique/getMoreDossiersAcademiques', this.params)
        }
    }

    // Ouvre le validateur de dossier
    openValidator (row: any) {
        this.dossier_id = row.id
        if (this.dossier_id !== 0) {
            this.$store.commit('dossieracademique/SET_VIEW_DOSSIER', true)
        }
    }

    // Relance email
    relanceEmail (row: any) {
        this.dossier_id = row.item.id
        const params = { relaunch: 1 }
        if (this.dossier_id !== 0) {
            this.$store.dispatch('dossieracademique/updateDossierAcademique', { dossier_id: this.dossier_id, payload: params })
        }
    }

    // Ouvre le popup de classement
    openCommentaireIntervenant (row: any) {
        this.showCommentaireIntervenant = true
        this.user_select = row.user
    }

    // Ferme la popup de commentaire intervenant
    closeCommentaireIntervenant (retour = null) {
        const findIndex = this.$store.state.dossieracademique.dossiersAcademiques.findIndex((dossier: { user_id: any }) => dossier.user_id === this.user_select.id)
        const updateCandidat = _.cloneDeep(this.$store.state.dossieracademique.dossiersAcademiques[findIndex])
        updateCandidat.user = this.user_select
        Vue.set(this.$store.state.dossieracademique.dossiersAcademiques, findIndex, updateCandidat)
        if (retour != null) {
            if (this.user_select.comment) {
                this.user_select.comment.body = retour
            } else {
                this.user_select.comment = {
                    body: retour
                }
            }
        }
        this.showCommentaireIntervenant = false
        this.user_select = {}
        // this.$store.dispatch('dossieracademique/getDossiersSelections', { session_id: this.$store.state.session.sessionSelect.id, matiere_id: this.$store.state.matiere.matiereSelect.id })
    }

    /**
     * Récupération des events du tableau
     * params[0] => l'action
     * params[1] => l'id de l'item
     */
    handleTableEvent (paParams: any): void
    {
        if (paParams && paParams[0] && paParams[1])
        {
            switch (paParams[0])
            {
                case 'edit':
                    this.openValidator(paParams[1])
                    break
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'openComment':
                    this.openCommentaireIntervenant(paParams[1])
                    break
                case 'filterHandler':
                    this.loadHandler(paParams[1])
                    break
                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break
                case 'infoIntervenant':
                    this.infoIntervenantHandler(paParams[1])
                    break
                default:
                    break
            }
        }
    }

    setDataForGenericTab(poData: any, isLoadMore = false)
    {
        if (!isLoadMore)
        {
            this.dataForTab = []
        }
        if (poData)
        {
            for (const result of poData)
            {
                if (result) {
                    // Colonne commentaires
                    const can = this.$store.getters['auth/can'](Ability.RH_DOSADM_MANAGE)
                    const icone = checkIcone(Ability.RH_DOSADM_MANAGE, can)

                    const nameIcon      = 'comment-alt'
                    const validation = this.getPuceColorValidation(result)
                    const commentColor  = result.user && result.user.comment && result.user.comment !== undefined && result.user.comment.body !== '' &&  result.user.comment.body !== null ? 'text-primary' : 'text-tertiary'
                    const name          = result.user && result.user.name ? result.user.name : ' - '
                    const first_name    = result.user && result.user.first_name ? result.user.first_name : ' - '
                    const filiere       = result.concour && result.concour.code ? result.concour.code : '-'
                    const matiere       = result.matiere && result.matiere.name ? result.matiere.name : '-'
                    const submitted_at  = result.submitted_at ? this.formatteDate(result.submitted_at) : '-'
                    let postes_souhaits   = ''

                    for (const s in result.postes_souhaits) {
                        if (Number(s) === (result.postes_souhaits.length - 1)) {
                            postes_souhaits += result.postes_souhaits[s].name
                        } else {
                            postes_souhaits += result.postes_souhaits[s].name + ', '
                        }
                    }

                    const line = [
                        { label: icone.label,       item: result,           type: 'action',  typeAction: 'edit', class: 'commons_first_action_button', icon: icone.icon, disabled: false },
                        { label: '',            item: validation,            type: 'icons',   typeAction: null,     class: 'text-center' },
                        { label: 'Commentaire',         item: result,           type: 'action',  typeAction: 'openComment',         class: commentColor, icon: nameIcon, disabled: !this.$store.getters['auth/can'](Ability.RH_SPS_MANAGE) },
                        // { label: 'Nom',             item: name,             type: 'text', typeAction: null, class: '' },
                        // { label: 'Prénom',          item: first_name,       type: 'text', typeAction: null, class: '' },
                        { label: '', item: result.user.id, type: 'actionText', typeAction: 'infoIntervenant', class: 'text-info item_action', text: name + ' ' + first_name },
                        { label: 'Poste',           item: postes_souhaits,  type: 'text', typeAction: null, class: '' },
                        { label: 'Filière',         item: filiere,          type: 'text', typeAction: null, class: '' },
                        { label: 'Matière',         item: matiere,          type: 'text', typeAction: null, class: '' },
                        { label: 'submitted_at',    item: submitted_at,     type: 'text', typeAction: null, class: '' }

                    ]
                    this.dataForTab.push(line)
                }
            }
        }
    }

    infoIntervenantHandler(user_id: any) {
        this.user_id_temp  = user_id
        this.showModalInfoIntervenant = true
    }

    /** Formattage de date */
    formatteDate (date: Date) {
        return formatDate(date)
    }

    /** Puce de l'état */
    getPuceColorValidation(result: any) {
        let class_affichage = 'text-tertiary'
        let title = ''
        if (result) {
            switch (true) {
                case result.etat === Etat.ETAT_INVISIBLE:
                    class_affichage = 'text-tertiary'
                    title = ''
                    break
                case result.etat === Etat.ETAT_VIERGE:
                    title   = 'Publié'
                    class_affichage = 'text-secondary'
                    break
                case result.etat === Etat.ETAT_DEPOSE:
                    title   = 'Déposé'
                    class_affichage = 'text-info'
                    break
                case result.etat === Etat.ETAT_VALIDE:
                    title   = 'Validé'
                    class_affichage = 'text-success'
                    break
                case result.etat === Etat.ETAT_REJETE:
                    title   = 'Rejeté'
                    class_affichage = 'text-danger'
                    break
            }
        }
        return [{ name: 'circle', class: class_affichage, title: title }]
    }

    // Chargement de l'interface
    load () {
        this.$store.dispatch('concour/getConcoursActifs').then(() => {
            this.$store.dispatch('matiere/getMatieres').then(() => {
                this.$store.dispatch('poste/getPostes', { type: PosteType.TYPE_PEDAGOGIQUE, context: (PosteContext.CONTEXT_SOUHAIT) }).then(() => {
                    this.setDataForGenericTab(this.$store.state.dossieracademique.dossiersAcademiques)
                    this.setFiltersForGenericTab()
                })
            })
        })
    }

    mounted () {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            this.load()
        }
    }
}
